/* eslint-disable @typescript-eslint/no-use-before-define */

import {
  FilterPanelState,
  IdType,
  SearchProps,
  SearchPropsBody,
} from '../types';

export const filterPanelChangeManager = filterPanelChangeManagerFn();

interface CommittedState {
  hash: string;
  blocked: boolean;
  committedSearchProps: SearchPropsBody;
}

function filterPanelChangeManagerFn() {
  const committedState: CommittedState = {
    hash: '',
    blocked: true,
    committedSearchProps: {
      eventTypePortalItems: [],
      state: {
        events: [],
        idType: IdType.none,
        month: '',
        portals: [],
        value: '',
      },
    },
  };

  return {
    isSubmittable,
    commitSearchProps,
    getCommittedSearchProps,
    setSubmitBlocked,
  };

  function isSubmittable(state: FilterPanelState) {
    if (committedState.blocked) {
      return false;
    }

    return hasChanged(state);
  }

  function getCommittedSearchProps(pageIndex: number): SearchProps {
    return { ...committedState.committedSearchProps, pageIndex };
  }

  function commitSearchProps(searchProps: SearchPropsBody) {
    committedState.hash = getHash(searchProps.state);
    committedState.committedSearchProps = searchProps;
  }

  function setSubmitBlocked(blocked: boolean) {
    committedState.blocked = blocked;
  }

  function hasChanged(state: FilterPanelState) {
    const hash = getHash(state);
    return hash !== committedState.hash;
  }

  function getHash({
    month,
    portals,
    events,
    idType,
    value,
  }: FilterPanelState) {
    return `${month}|${portals.sort().join()}|${events
      .sort()
      .join()}|${idType}|${value}`;
  }
}
